/* -------------------------------------------------------------------------- */
/*                               Constants configs                            */
/* -------------------------------------------------------------------------- */

/**
 * An object containing accepted MIME types and their associated file extensions.
 *  For a list of common MIME types, see:
 * * [MDN Web Docs: Common MIME Types](https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types)
 *
 *
 * @constant {Object} ACCEPTED_MIME_TYPES
 * @property {string[]} application/pdf - Accepted extensions for PDF files.
 * @property {string[]} image/png - Accepted extensions for PNG images.
 * @property {string[]} image/jpeg - Accepted extensions for JPEG images.
 * @property {string[]} application/msword - Accepted extensions for Word documents (DOC).
 * @property {string[]} text/plain - Accepted extensions for plain text files.
 * @property {string[]} application/vnd.ms-excel - Accepted extensions for Excel files (XLS).
 * @property {string[]} application/vnd.openxmlformats-officedocument.spreadsheetml.sheet - Accepted extensions for modern Excel files (XLSX).
 * @property {string[]} application/vnd.openxmlformats-officedocument.wordprocessingml.document - Accepted extensions for modern Word documents (DOCX).
 */
export const ACCEPTED_MIME_TYPES = {
	'application/pdf': ['.pdf'],
	'image/png': ['.png'],
	'image/jpeg': ['.jpeg', '.jpg'],
};

const MAX_SIZE_MB = 20; // 20 MB

export const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;
